<template>
<div>
  <div class="cstm-tab-holder schedule_tab">
    <div class="cstm-unique-tab flex mb-4" :class="[edit_permission() ? 'cstmed_width' : '']">
      <div class="flex flex-wrap">
        <div class="tab-name flex" :class="{'activeTab': mon}" @click="tab('mon')" v-if="activeDays[0]">
          Monday
          <div class="info_time_holder">
            <span class="material-icons-outlined info_icon">info</span>
            <div class="content_holder">
              <div class="">School Start Time: {{ flatPickerConfig[0].minTime | OnlytimeFormatLocalization }}</div>
              <div class="">School End Time: {{ flatPickerConfig[0].maxTime | OnlytimeFormatLocalization }}</div>
            </div>
          </div>
        </div>
        <div class="tab-name flex" :class="{'activeTab': tues}" @click="tab('tues')" v-if="activeDays[1]">
          Tuesday
          <div class="info_time_holder">
            <span class="material-icons-outlined info_icon">info</span>
            <div class="content_holder">
              <div class="">School Start Time: {{ flatPickerConfig[1].minTime | OnlytimeFormatLocalization }}</div>
              <div class="">School End Time: {{ flatPickerConfig[1].maxTime | OnlytimeFormatLocalization }}</div>
            </div>
          </div>
        </div>
        <div class="tab-name flex" :class="{'activeTab': wed}" @click="tab('wed')" v-if="activeDays[2]">
          Wednesday
          <div class="info_time_holder">
            <span class="material-icons-outlined info_icon">info</span>
            <div class="content_holder">
              <div class="">School Start Time: {{ flatPickerConfig[2].minTime | OnlytimeFormatLocalization }}</div>
              <div class="">School End Time: {{ flatPickerConfig[2].maxTime | OnlytimeFormatLocalization }}</div>
            </div>
          </div>
        </div>
        <div class="tab-name flex" :class="{'activeTab': thurs}" @click="tab('thurs')" v-if="activeDays[3]">
          Thursday
          <div class="info_time_holder">
            <span class="material-icons-outlined info_icon">info</span>
            <div class="content_holder">
              <div class="">School Start Time: {{ flatPickerConfig[3].minTime | OnlytimeFormatLocalization }}</div>
              <div class="">School End Time: {{ flatPickerConfig[3].maxTime | OnlytimeFormatLocalization }}</div>
            </div>
          </div>
        </div>
        <div class="tab-name flex" :class="{'activeTab': fri}" @click="tab('fri')" v-if="activeDays[4]">
          Friday
          <div class="info_time_holder">
            <span class="material-icons-outlined info_icon">info</span>
            <div class="content_holder">
              <div class="">School Start Time: {{ flatPickerConfig[4].minTime | OnlytimeFormatLocalization }}</div>
              <div class="">School End Time: {{ flatPickerConfig[4].maxTime | OnlytimeFormatLocalization }}</div>
            </div>
          </div>
        </div>
        <div class="tab-name flex" :class="{'activeTab': sat}" @click="tab('sat')" v-if="activeDays[5]">
          Saturday
          <div class="info_time_holder">
            <span class="material-icons-outlined info_icon">info</span>
            <div class="content_holder">
              <div class="">School Start Time: {{ flatPickerConfig[5].minTime | OnlytimeFormatLocalization }}</div>
              <div class="">School End Time: {{ flatPickerConfig[5].maxTime | OnlytimeFormatLocalization }}</div>
            </div>
          </div>
        </div>
        <div class="tab-name flex" :class="{'activeTab': sun}" @click="tab('sun')" v-if="activeDays[6]">
          Sunday
          <div class="info_time_holder">
            <span class="material-icons-outlined info_icon">info</span>
            <div class="content_holder">
              <div class="">School Start Time: {{ flatPickerConfig[6].minTime | OnlytimeFormatLocalization }}</div>
              <div class="">School End Time: {{ flatPickerConfig[6].maxTime | OnlytimeFormatLocalization }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cstm_all_content_holder" :class="[edit_permission() ? 'mt-n-54' : '']">
      <!-- each tab content -->
      <div v-if="mon">
        <div class="flex flex-1 justify-end mb-5">
          <vs-button v-if="edit_permission()" @click="addPeriod('monday', 1)">Add Period</vs-button>
        </div>

        <div class="flex flex-1 flex-col" v-for="(mondayPeriod, index) in monday_schedule" :key="index" :class="[mondayPeriod.is_period === 1 && index != 0 ? 'class_period_holder' : '']">
          <div class="flex flex-wrap items-end">
            <div class="w-full flex flex-wrap" :class="[monday_schedule.length > 1 ? 'md:w-11/12' : 'md:w-full' , parseInt(scheduleErrorRows[0]) === index ? 'errorPicker' : 'abcdef']">
              <div class="md:w-1/4 w-full p-1">
                <label v-if="mondayPeriod.is_period === 1" class="vs-input--label">Period</label>
                <v-select 
                  v-if="mondayPeriod.is_period === 1"
                  class="w-full cstm_vue_select"
                  placeholder="Select Subject"
                  :options="subject_list"
                  :reduce="option => option.id"
                  label="subject_name"
                  :clearable="false"
                  v-model="mondayPeriod.subject_id"
                  :disabled="is_disabled"
                />
                
                <vs-input 
                  v-else
                  class="w-full" 
                  label="Break"
                  placeholder="Break Name"
                  v-model="mondayPeriod.name"
                  :disabled="is_disabled"
                />
              </div>

              <div v-if="mondayPeriod.is_period === 1" class="md:w-1/4 w-full p-1">
                <label class="vs-input--label">Add Teacher</label>
                <v-select
                  class="w-full cstm_vue_select" 
                  placeholder="Select Teacher"
                  :options="teacher_list"
                  :reduce="option => option.id"
                  label="full_name"
                  :clearable="false"
                  v-model="mondayPeriod.teacher_id"
                  :disabled="is_disabled"
                />
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">Start Time</label>
                <div class="h-37">
                <flat-pickr
                  class="w-full" 
                  placeholder="Start Time"
                  :config="flatPickerConfig[0]"
                  v-model="mondayPeriod.start_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">End Time</label>
                <div class="h-37">
                <flat-pickr 
                  class="w-full" 
                  placeholder="End Time"
                  :config="flatPickerConfig[0]"
                  v-model="mondayPeriod.end_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>
            </div>
            <div class="md:w-1/12 w-full">
              <div class="p-1">
                <vs-button v-if="monday_schedule.length > 1 && checkDeletePermission()" type="border" color="danger" class="includeIcon includeIconOnly block ml-auto" icon-pack="feather" icon="icon-trash" @click="removePeriod('monday', index)"></vs-button>
              </div>
            </div>
          </div>
          <a v-if="mondayPeriod.is_period === 1 && monday_schedule.length - 1 === index && edit_permission()" class="p-1" @click="addPeriod('monday', 0)">Add Break</a>
        </div>
        <vs-divider />

        <div class="flex flex-1 justify-end mt-10">
          <vs-button v-if="edit_permission()" @click="saveTimeTable('monday')">Save Schedule</vs-button>
        </div>
      </div>

      <!-- each tab content -->
      <div v-if="tues">
        <div class="flex flex-1 justify-end mb-5">
          <vs-button v-if="edit_permission()" @click="addPeriod('tuesday', 1)">Add Period</vs-button>
        </div>

        <div class="flex flex-1 flex-col" v-for="(tuesdayPeriod, index) in tuesday_schedule" :key="index" :class="[tuesdayPeriod.is_period === 1 && index != 0 ? 'class_period_holder' : '']">
          <div class="flex flex-wrap items-end">
            <div class="w-full flex flex-wrap" :class="[tuesday_schedule.length > 1 ? 'md:w-11/12' : 'md:w-full' , parseInt(scheduleErrorRows[1]) === index ? 'errorPicker' : 'abcdef']">
              <div class="md:w-1/4 w-full p-1">
              <label v-if="tuesdayPeriod.is_period === 1" class="vs-input--label">Period</label>
                <v-select 
                  v-if="tuesdayPeriod.is_period === 1"
                  class="w-full cstm_vue_select"
                  placeholder="Select Subject"
                  :options="subject_list"
                  :reduce="option => option.id"
                  label="subject_name"
                  :clearable="false"
                  v-model="tuesdayPeriod.subject_id"
                  :disabled="is_disabled"
                />

                <vs-input 
                  v-else
                  class="w-full" 
                  label="Break"
                  placeholder="Break Name"
                  v-model="tuesdayPeriod.name"
                  :disabled="is_disabled"
                />
              </div>

              <div v-if="tuesdayPeriod.is_period === 1" class="md:w-1/4 w-full p-1">
                <label class="vs-input--label">Add Teacher</label>
                <v-select
                  class="w-full cstm_vue_select" 
                  placeholder="Select Teacher"
                  :options="teacher_list"
                  :reduce="option => option.id"
                  label="full_name"
                  :clearable="false"
                  v-model="tuesdayPeriod.teacher_id"
                  :disabled="is_disabled"
                />
              </div>
              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">Start Time</label>
                <div class="h-37">
                <flat-pickr
                  class="w-full" 
                  placeholder="Start Time"
                  :config="flatPickerConfig[1]"
                  v-model="tuesdayPeriod.start_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">End Time</label>
                <div class="h-37">
                <flat-pickr 
                  class="w-full" 
                  placeholder="End Time"
                  :config="flatPickerConfig[1]"
                  v-model="tuesdayPeriod.end_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>
            </div>

            <div class="md:w-1/12 w-full">
              <div class="p-1">
                <vs-button v-if="tuesday_schedule.length > 1 && edit_permission()" type="border" color="danger" class="includeIcon includeIconOnly block ml-auto" icon-pack="feather" icon="icon-trash" @click="removePeriod('tuesday', index)"></vs-button>
              </div>
            </div>
          </div>
          <a v-if="tuesdayPeriod.is_period === 1 && tuesday_schedule.length - 1 === index && edit_permission()" class="p-1" @click="addPeriod('tuesday', 0)">Add Break</a>
        </div>
        <vs-divider />

        <div class="flex flex-1 justify-end mt-10">
          <vs-button v-if="edit_permission()" @click="saveTimeTable('tuesday')">Save Schedule</vs-button>
        </div>
      </div>

      <!-- each tab content -->
      <div v-if="wed">
        <div class="flex flex-1 justify-end mb-5">
          <vs-button v-if="edit_permission()" @click="addPeriod('wednesday', 1)">Add Period</vs-button>
        </div>

        <div class="flex flex-1 flex-col" v-for="(wednesdayPeriod, index) in wednesday_schedule" :key="index" :class="[wednesdayPeriod.is_period === 1 && index != 0 ? 'class_period_holder' : '']">
          <div class="flex flex-wrap items-end">
            <div class="w-full flex flex-wrap" :class="[wednesday_schedule.length > 1 ? 'md:w-11/12' : 'md:w-full' , parseInt(scheduleErrorRows[2]) === index ? 'errorPicker' : 'abcdef']">
              <div class="md:w-1/4 w-full p-1">
                <label v-if="wednesdayPeriod.is_period === 1" class="vs-input--label">Period</label>
                <v-select 
                  v-if="wednesdayPeriod.is_period === 1"
                  class="w-full cstm_vue_select"
                  placeholder="Select Subject"
                  :options="subject_list"
                  :reduce="option => option.id"
                  label="subject_name"
                  :clearable="false"
                  v-model="wednesdayPeriod.subject_id"
                  :disabled="is_disabled"
                />

                <vs-input 
                  v-else
                  class="w-full" 
                  label="Break"
                  placeholder="Break Name"
                  v-model="wednesdayPeriod.name"
                  :disabled="is_disabled"
                />
              </div>

              <div v-if="wednesdayPeriod.is_period === 1" class="md:w-1/4 w-full p-1">
                <label class="vs-input--label">Add Teacher</label>
                <v-select
                  class="w-full cstm_vue_select" 
                  placeholder="Select Teacher"
                  :options="teacher_list"
                  :reduce="option => option.id"
                  label="full_name"
                  :clearable="false"
                  v-model="wednesdayPeriod.teacher_id"
                  :disabled="is_disabled"
                />
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">Start Time</label>
                <div class="h-37">
                <flat-pickr
                  class="w-full" 
                  placeholder="Start Time"
                  :config="flatPickerConfig[2]"
                  v-model="wednesdayPeriod.start_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">End Time</label>
                <div class="h-37">
                <flat-pickr 
                  class="w-full" 
                  placeholder="End Time"
                  :config="flatPickerConfig[2]"
                  v-model="wednesdayPeriod.end_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>
            </div>
            <div class="md:w-1/12 w-full">
              <vs-button v-if="wednesday_schedule.length > 1 && edit_permission()" type="border" color="danger" class="includeIcon includeIconOnly block ml-auto" icon-pack="feather" icon="icon-trash" @click="removePeriod('wednesday', index)"></vs-button>
            </div>
          </div>
          <a v-if="wednesdayPeriod.is_period === 1 && wednesday_schedule.length - 1 === index && edit_permission()" class="p-1" @click="addPeriod('wednesday', 0)">Add Break</a>
        </div>
        <vs-divider />

        <div class="flex flex-1 justify-end mt-10">
          <vs-button v-if="edit_permission()" @click="saveTimeTable('wednesday')">Save Schedule</vs-button>
        </div>
      </div>

      <!-- each tab content -->
      <div v-if="thurs">
        <div class="flex flex-1 justify-end mb-5">
          <vs-button v-if="edit_permission()" @click="addPeriod('thursday', 1)">Add Period</vs-button>
        </div>

        <div class="flex flex-1 flex-col" v-for="(thursdayPeriod, index) in thursday_schedule" :key="index" :class="[thursdayPeriod.is_period === 1 && index != 0 ? 'class_period_holder' : '']">
          <div class="flex flex-wrap items-end">
            <div class="w-full flex flex-wrap" :class="[thursday_schedule.length > 1 ? 'md:w-11/12' : 'md:w-full' , parseInt(scheduleErrorRows[3]) === index ? 'errorPicker' : 'abcdef']">
              <div class="md:w-1/4 w-full p-1">
                <label v-if="thursdayPeriod.is_period === 1" class="vs-input--label">Period</label>
                <v-select 
                  v-if="thursdayPeriod.is_period === 1"
                  class="w-full cstm_vue_select"
                  placeholder="Select Subject"
                  :options="subject_list"
                  :reduce="option => option.id"
                  label="subject_name"
                  :clearable="false"
                  v-model="thursdayPeriod.subject_id"
                  :disabled="is_disabled"
                />

                <vs-input 
                  v-else
                  class="w-full" 
                  label="Break"
                  placeholder="Break Name"
                  v-model="thursdayPeriod.name"
                  :disabled="is_disabled"
                />
              </div>

              <div v-if="thursdayPeriod.is_period === 1" class="md:w-1/4 w-full p-1">
                <label class="vs-input--label">Add Teacher</label>
                <v-select
                  class="w-full cstm_vue_select" 
                  placeholder="Select Teacher"
                  :options="teacher_list"
                  :reduce="option => option.id"
                  label="full_name"
                  :clearable="false"
                  v-model="thursdayPeriod.teacher_id"
                  :disabled="is_disabled"
                />
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">Start Time</label>
                <div class="h-37">
                <flat-pickr
                  class="w-full" 
                  placeholder="Start Time"
                  :config="flatPickerConfig[3]"
                  v-model="thursdayPeriod.start_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">End Time</label>
                <div class="h-37">
                <flat-pickr 
                  class="w-full" 
                  placeholder="End Time"
                  :config="flatPickerConfig[3]"
                  v-model="thursdayPeriod.end_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>
            </div>
            <div class="md:w-1/12 w-full">
              <vs-button v-if="thursday_schedule.length > 1 && edit_permission()" type="border" color="danger" class="includeIcon includeIconOnly block ml-auto" icon-pack="feather" icon="icon-trash" @click="removePeriod('thursday', index)"></vs-button>
            </div>
          </div>
          <a v-if="thursdayPeriod.is_period === 1 && thursday_schedule.length - 1 === index && edit_permission()" class="p-1" @click="addPeriod('thursday', 0)">Add Break</a>
        </div>
        <vs-divider />

        <div class="flex flex-1 justify-end mt-10">
          <vs-button v-if="edit_permission()" @click="saveTimeTable('thursday')">Save Schedule</vs-button>
        </div>
      </div>

      <!-- each tab content -->
      <div v-if="fri">
        <div class="flex flex-1 justify-end mb-5">
          <vs-button v-if="edit_permission()" @click="addPeriod('friday', 1)">Add Period</vs-button>
        </div>

        <div class="flex flex-1 flex-col" v-for="(fridayPeriod, index) in friday_schedule" :key="index" :class="[fridayPeriod.is_period === 1 && index != 0 ? 'class_period_holder' : '']">
          <div class="flex flex-wrap items-end">
            <div class="w-full flex flex-wrap" :class="[friday_schedule.length > 1 ? 'md:w-11/12' : 'md:w-full' , parseInt(scheduleErrorRows[4]) === index ? 'errorPicker' : 'abcdef']">
              <div class="md:w-1/4 w-full p-1">
                <label v-if="fridayPeriod.is_period === 1" class="vs-input--label">Period</label>
                <v-select 
                  v-if="fridayPeriod.is_period === 1"
                  class="w-full cstm_vue_select"
                  placeholder="Select Subject"
                  :options="subject_list"
                  :reduce="option => option.id"
                  label="subject_name"
                  :clearable="false"
                  v-model="fridayPeriod.subject_id"
                  :disabled="is_disabled"
                />

                <vs-input 
                  v-else
                  class="w-full" 
                  label="Break"
                  placeholder="Break Name"
                  v-model="fridayPeriod.name"
                  :disabled="is_disabled"
                />
              </div>

              <div v-if="fridayPeriod.is_period === 1" class="md:w-1/4 w-full p-1">
                <label class="vs-input--label">Add Teacher</label>
                <v-select
                  class="w-full cstm_vue_select" 
                  placeholder="Select Teacher"
                  :options="teacher_list"
                  :reduce="option => option.id"
                  label="full_name"
                  :clearable="false"
                  v-model="fridayPeriod.teacher_id"
                  :disabled="is_disabled"
                />
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">Start Time</label>
                <div class="h-37">
                <flat-pickr
                  class="w-full" 
                  placeholder="Start Time"
                  :config="flatPickerConfig[4]"
                  v-model="fridayPeriod.start_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">End Time</label>
                <div class="h-37">
                <flat-pickr 
                  class="w-full" 
                  placeholder="End Time"
                  :config="flatPickerConfig[4]"
                  v-model="fridayPeriod.end_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>
            </div>
            <div class="md:w-1/12 w-full">
              <vs-button v-if="friday_schedule.length > 1 && edit_permission()" type="border" color="danger" class="includeIcon includeIconOnly block ml-auto" icon-pack="feather" icon="icon-trash" @click="removePeriod('friday', index)"></vs-button>
            </div>
          </div>
          <a v-if="fridayPeriod.is_period === 1 && friday_schedule.length - 1 === index && edit_permission()" class="p-1" @click="addPeriod('friday', 0)">Add Break</a>
        </div>
        <vs-divider />

        <div class="flex flex-1 justify-end mt-10">
          <vs-button v-if="edit_permission()" @click="saveTimeTable('friday')">Save Schedule</vs-button>
        </div>
      </div>

      <!-- each tab content -->
      <div v-if="sat">
        <div class="flex flex-1 justify-end mb-5">
          <vs-button v-if="edit_permission()" @click="addPeriod('saturday', 1)">Add Period</vs-button>
        </div>

        <div class="flex flex-1 flex-col" v-for="(saturdayPeriod, index) in saturday_schedule" :key="index" :class="[saturdayPeriod.is_period === 1 && index != 0 ? 'class_period_holder' : '']">
          <div class="flex flex-wrap items-end">
            <div class="w-full flex flex-wrap" :class="[saturday_schedule.length > 1 ? 'md:w-11/12' : 'md:w-full' , parseInt(scheduleErrorRows[5]) === index ? 'errorPicker' : 'abcdef']">
              <div class="md:w-1/4 w-full p-1">
                <label v-if="saturdayPeriod.is_period === 1" class="vs-input--label">Period</label>
                <v-select 
                  v-if="saturdayPeriod.is_period === 1"
                  class="w-full cstm_vue_select"
                  placeholder="Select Subject"
                  :options="subject_list"
                  :reduce="option => option.id"
                  label="subject_name"
                  :clearable="false"
                  v-model="saturdayPeriod.subject_id"
                  :disabled="is_disabled"
                />

                <vs-input 
                  v-else
                  class="w-full" 
                  label="Break"
                  placeholder="Break Name"
                  v-model="saturdayPeriod.name"
                  :disabled="is_disabled"
                />
              </div>

              <div v-if="saturdayPeriod.is_period === 1" class="md:w-1/4 w-full p-1">
                <label class="vs-input--label">Add Teacher</label>
                <v-select
                  class="w-full cstm_vue_select" 
                  placeholder="Select Teacher"
                  :options="teacher_list"
                  :reduce="option => option.id"
                  label="full_name"
                  :clearable="false"
                  v-model="saturdayPeriod.teacher_id"
                  :disabled="is_disabled"
                />
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">Start Time</label>
                <div class="h-37">
                <flat-pickr
                  class="w-full" 
                  placeholder="Start Time"
                  :config="flatPickerConfig[5]"
                  v-model="saturdayPeriod.start_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">End Time</label>
                <div class="h-37">
                <flat-pickr 
                  class="w-full" 
                  placeholder="End Time"
                  :config="flatPickerConfig[5]"
                  v-model="saturdayPeriod.end_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>
            </div>
            <div class="md:w-1/12 w-full">
              <vs-button v-if="saturday_schedule.length > 1 && edit_permission()" type="border" color="danger" class="includeIcon includeIconOnly block ml-auto" icon-pack="feather" icon="icon-trash" @click="removePeriod('saturday', index)"></vs-button>
            </div>
          </div>
          <a v-if="saturdayPeriod.is_period === 1 && saturday_schedule.length - 1 === index && edit_permission()" class="p-1" @click="addPeriod('saturday', 0)">Add Break</a>
        </div>
        <vs-divider />

        <div class="flex flex-1 justify-end mt-10">
          <vs-button v-if="edit_permission()" @click="saveTimeTable('saturday')">Save Schedule</vs-button>
        </div>
      </div>

      <!-- each tab content -->
      <div v-if="sun">
        <div class="flex flex-1 justify-end mb-5">
          <vs-button v-if="edit_permission()" @click="addPeriod('sunday', 1)">Add Period</vs-button>
        </div>

        <div class="flex flex-1 flex-col" v-for="(sundayPeriod, index) in sunday_schedule" :key="index" :class="[sundayPeriod.is_period === 1 && index != 0 ? 'class_period_holder' : '']">
          <div class="flex flex-wrap items-end">
            <div class="w-full flex flex-wrap" :class="[sunday_schedule.length > 1 ? 'md:w-11/12' : 'md:w-full' , parseInt(scheduleErrorRows[6]) === index ? 'errorPicker' : 'abcdef']">
              <div class="md:w-1/4 w-full p-1">
                <label v-if="sundayPeriod.is_period === 1" class="vs-input--label">Period</label>
                <v-select 
                  v-if="sundayPeriod.is_period === 1"
                  class="w-full cstm_vue_select"
                  placeholder="Select Subject"
                  :options="subject_list"
                  :reduce="option => option.id"
                  label="subject_name"
                  :clearable="false"
                  v-model="sundayPeriod.subject_id"
                  :disabled="is_disabled"
                />

                <vs-input 
                  v-else
                  class="w-full" 
                  label="Break"
                  placeholder="Break Name"
                  v-model="sundayPeriod.name"
                  :disabled="is_disabled"
                />
              </div>

              <div v-if="sundayPeriod.is_period === 1" class="md:w-1/4 w-full p-1">
                <label class="vs-input--label">Add Teacher</label>
                <v-select
                  class="w-full cstm_vue_select" 
                  placeholder="Select Teacher"
                  :options="teacher_list"
                  :reduce="option => option.id"
                  label="full_name"
                  :clearable="false"
                  v-model="sundayPeriod.teacher_id"
                  :disabled="is_disabled"
                />
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">Start Time</label>
                <div class="h-37">
                <flat-pickr
                  class="w-full" 
                  placeholder="Start Time"
                  :config="flatPickerConfig[6]"
                  v-model="sundayPeriod.start_time"
                  :disabled="is_disabled"
                />
                </div>
              </div>

              <div class="md:w-1/4 w-full p-1 flat_pickr_holder">
                <label class="vs-input--label">End Time</label>
                <div class="h-37">
                  <flat-pickr 
                    class="w-full" 
                    placeholder="End Time"
                    :config="flatPickerConfig[6]"
                    v-model="sundayPeriod.end_time"
                    :disabled="is_disabled"
                  />
                </div>
              </div>
            </div>
            <div class="md:w-1/12 w-full">
              <vs-button v-if="sunday_schedule.length > 1 && edit_permission()" type="border" color="danger" class="includeIcon includeIconOnly block ml-auto" icon-pack="feather" icon="icon-trash" @click="removePeriod('sunday', index)"></vs-button>
            </div>
          </div>
          <a v-if="sundayPeriod.is_period === 1 && sunday_schedule.length - 1 === index && edit_permission()" class="p-1" @click="addPeriod('sunday', 0)">Add Break</a>
        </div>
        <vs-divider />

        <div class="flex flex-1 justify-end mt-10">
          <vs-button v-if="edit_permission()" @click="saveTimeTable('sunday')">Save Schedule</vs-button>
        </div>
      </div>
    </div>
  </div>

  <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-show="overlapModal" :class="{show: overlapModal}">
    <div class="cstm-modal">
      <div class="p-4 modal-content">
        There is an overlap with this setting.
        <div class="flex flex-1 justify-end mt-8">
          <vs-button type="border" color="danger" @click="overlapModal = false">Cancel</vs-button>
          <vs-button class="ml-4" @click="finalSave(tempDay, tempPayload)">Proceed</vs-button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { checkClassOverlap, createClassSchedule, getClassSchedule, subjectList } from '@/api/classes'
import {fetchScheduleApi} from '@/api/generalapi'

export default {
  name: 'ScheduleSettings',
  mixins: [PermissionMiddleware],
  props: ['teacher_list', 'class_id', 'edit_permission'],
  components: {
    vSelect,
    flatPickr
  },
  data () {
    return {
      monday_schedule: [{ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: 1 }],
      tuesday_schedule: [{ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: 1 }],
      wednesday_schedule: [{ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: 1 }],
      thursday_schedule: [{ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: 1 }],
      friday_schedule: [{ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: 1 }],
      saturday_schedule: [{ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: 1 }],
      sunday_schedule: [{ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: 1 }],
      flatPickerDefaultConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i:S"
      },
      flatPickerConfig: [],
      customer_id: null,
      days: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      schoolScheduleSettings: [],
      activeDays: [],
      activeTime: [],
      subject_list: [],
      mon: false,
      tues: false,
      wed: false,
      thurs: false,
      fri: false,
      sat: false,
      sun: false,
      scheduleErrorRows: [null, null, null, null, null, null, null],
      overlapModal: false,
      tempDay: null,
      tempPayload: null,
      overlapClassTeacherDetails: [],
      overlapClassRoomDetails: []
    }
  },
  created () {
    this.customer_id = localStorage.getItem('customer_id')
    this.getSubjectList()
    this.getTimeTable()
  },
  computed: {
    is_disabled () {
      return !this.edit_permission()
    }
  },
  mounted () {
    this.displayTimeTable()
  },
  methods: {
    async displayTimeTable () {
      await this.getSchoolScheduleSettings()
      const result = this.activeDays.findIndex(ele => ele === true)
      if (result === 0) {
        this.tab('mon')
      } else if (result === 1) {
        this.tab('tues')
      } else if (result === 2) {
        this.tab('wed')
      } else if (result === 3) {
        this.tab('thurs')
      } else if (result === 4) {
        this.tab('fri')
      } else if (result === 5) {
        this.tab('sat')
      } else if (result === 6) {
        this.tab('sun')
      } 
    },
    tab (type) {
      if (type === 'mon') {
        this.mon = true
        this.tues = false
        this.wed = false
        this.thurs = false
        this.fri = false
        this.sat = false
        this.sun = false
      } else if (type === 'tues') {
        this.mon = false
        this.tues = true
        this.wed = false
        this.thurs = false
        this.fri = false
        this.sat = false
        this.sun = false
      } else if (type === 'wed') {
        this.mon = false
        this.tues = false
        this.wed = true
        this.thurs = false
        this.fri = false
        this.sat = false
        this.sun = false
      } else if (type === 'thurs') {
        this.mon = false
        this.tues = false
        this.wed = false
        this.thurs = true
        this.fri = false
        this.sat = false
        this.sun = false
      } else if (type === 'fri') {
        this.mon = false
        this.tues = false
        this.wed = false
        this.thurs = false
        this.fri = true
        this.sat = false
        this.sun = false
      } else if (type === 'sat') {
        this.mon = false
        this.tues = false
        this.wed = false
        this.thurs = false
        this.fri = false
        this.sat = true
        this.sun = false
      } else if (type === 'sun') {
        this.mon = false
        this.tues = false
        this.wed = false
        this.thurs = false
        this.fri = false
        this.sat = false
        this.sun = true
      } 
    },
    async getSchoolScheduleSettings () {
      try {
        const response = await fetchScheduleApi(this.customer_id)
        this.schoolScheduleSettings = response.data.data.fetchUserScheduleSetting

        this.activeDays = this.schoolScheduleSettings.map(item => {
          return item.is_active
        })

        this.activeTime = this.schoolScheduleSettings.map(item => {
          return { start_time: item.start_time, end_time: item.end_time }
        })

        this.generateFlatPickrConfigs()
      } catch (e) {
        console.log(e)
      }
    },
    generateFlatPickrConfigs () {
      this.flatPickerConfig = this.activeTime.map(item => {
        return {
          ...this.flatPickerDefaultConfig,
          minTime: item.start_time.length === 5 ? `${item.start_time}:00` : item.start_time,
          maxTime: item.end_time.length === 5 ? `${item.end_time}:00` : item.end_time,
          defaultHour: item.start_time ? item.start_time.split(':')[0] : 0
        }
      })
    },
    addPeriod (day, period_type) {
      if (day === 'monday') {
        this.monday_schedule.push({ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: period_type })
      } else if (day === 'tuesday') {
        this.tuesday_schedule.push({ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: period_type })
      } else if (day === 'wednesday') {
        this.wednesday_schedule.push({ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: period_type })
      } else if (day === 'thursday') {
        this.thursday_schedule.push({ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: period_type })
      } else if (day === 'friday') {
        this.friday_schedule.push({ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: period_type })
      } else if (day === 'saturday') {
        this.saturday_schedule.push({ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: period_type })
      } else if (day === 'sunday') {
        this.sunday_schedule.push({ name: '', start_time: '', end_time: '', teacher_id: null, subject_id: null, is_period: period_type })
      }
    },
    removePeriod (day, index) {
      if (day === 'monday') {
        this.monday_schedule.splice(index, 1)
      } else if (day === 'tuesday') {
        this.tuesday_schedule.splice(index, 1)
      } else if (day === 'wednesday') {
        this.wednesday_schedule.splice(index, 1)
      } else if (day === 'thursday') {
        this.thursday_schedule.splice(index, 1)
      } else if (day === 'friday') {
        this.friday_schedule.splice(index, 1)
      } else if (day === 'saturday') {
        this.saturday_schedule.splice(index, 1)
      } else if (day === 'sunday') {
        this.sunday_schedule.splice(index, 1)
      }
    },
    async saveTimeTable (day) {
      const payload = {
        customer_id: this.customer_id,
        class_id: this.class_id,
        day,
        periodArray: []
      }

      if (day === 'monday') {
        payload.periodArray = this.monday_schedule
      } else if (day === 'tuesday') {
        payload.periodArray = this.tuesday_schedule
      } else if (day === 'wednesday') {
        payload.periodArray = this.wednesday_schedule
      } else if (day === 'thursday') {
        payload.periodArray = this.thursday_schedule
      } else if (day === 'friday') {
        payload.periodArray = this.friday_schedule
      } else if (day === 'saturday') {
        payload.periodArray = this.saturday_schedule
      } else if (day === 'sunday') {
        payload.periodArray = this.sunday_schedule
      }

      const isOverlap = await this.checkOverlap(day, payload)

      if (!isOverlap) {
        this.finalSave(day, payload)
      }
    },
    async checkOverlap (day, payload) {
      try {
        this.$vs.loading({
          type: 'material',
          text: 'Checking for overlaps...'
        })

        const response = await checkClassOverlap(payload)

        if (response.status === 200) {
          this.$vs.loading.close()
          // Trigger modal open
          if (response.data.data.status) {
            this.overlapClassTeacherDetails = response.data.data.results
            this.overlapClassRoomDetails = response.data.data.room_check_results
            this.overlapModal = true
            this.tempDay = day
            this.tempPayload = payload
            return true
          } else {
            this.overlapModal = false
            return false
          }
        }
      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
      }
    },
    async finalSave (day, payload) {
      try {
        this.$vs.loading({
          type: 'material',
          text: 'Saving schedule...'
        })

        const response = await createClassSchedule(payload)

        if (response.status === 202) {
          this.$vs.loading.close()
          
          this.storeScheduleErrors(day, null)
          this.showSuccessMessage('Success', 'Schedule saved successfully', 'success')

          this.getSelectedSubjectsForClass()
        }

        this.overlapModal = false
      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
        this.overlapModal = false

        const error = e.data.message.split(':')
        const errorMsg = error[0]
        const errorIndex = error[1]
        this.storeScheduleErrors(day, errorIndex)
        this.showSuccessMessage('Error', errorMsg, 'danger')
      }
    },
    storeScheduleErrors (day, row_index) {
      if (day === 'monday') {
        this.scheduleErrorRows.splice(0, 1, row_index)
      } else if (day === 'tuesday') {
        this.scheduleErrorRows.splice(1, 1, row_index)
      } else if (day === 'wednesday') {
        this.scheduleErrorRows.splice(2, 1, row_index)
      } else if (day === 'thursday') {
        this.scheduleErrorRows.splice(3, 1, row_index)
      } else if (day === 'friday') {
        this.scheduleErrorRows.splice(4, 1, row_index)
      } else if (day === 'saturday') {
        this.scheduleErrorRows.splice(5, 1, row_index)
      } else if (day === 'sunday') {
        this.scheduleErrorRows.splice(6, 1, row_index)
      }
    },
    getSelectedSubjectsForClass () {
      const totalSchedule = new Set([
        ...this.monday_schedule, 
        ...this.tuesday_schedule,
        ...this.wednesday_schedule,
        ...this.thursday_schedule,
        ...this.friday_schedule,
        ...this.saturday_schedule,
        ...this.sunday_schedule
      ].filter(item => item.subject_id !== null).map(item => { return item.subject_id }))

      this.$emit('subjects_selected', totalSchedule)
    },
    async getTimeTable () {
      try {
        const payload = { 
          class_id: this.class_id,
          days: this.days
        }

        const response = await getClassSchedule(this.customer_id, payload)
        if (response.status === 202) {
          const schedule = response.data.data.class_setting_list


          this.days.map(day => {
            const filteredSchedule = schedule.filter(item => item.day === day)

            if (filteredSchedule.length > 0) {

              const daySchedule = filteredSchedule.map(item => {
                return { 
                  name: item.name, 
                  start_time: item.start_time, 
                  end_time: item.end_time, 
                  teacher_id: item.teacher_id, 
                  subject_id: item.subject_id,
                  is_period: item.is_period
                }
              })

              if (day === 'monday') {
                this.monday_schedule = daySchedule
              } else if (day === 'tuesday') {
                this.tuesday_schedule = daySchedule
              } else if (day === 'wednesday') {
                this.wednesday_schedule = daySchedule
              } else if (day === 'thursday') {
                this.thursday_schedule = daySchedule
              } else if (day === 'friday') {
                this.friday_schedule = daySchedule
              } else if (day === 'saturday') {
                this.saturday_schedule = daySchedule
              } else if (day === 'sunday') {
                this.sunday_schedule = daySchedule
              }
            }
          })

          this.getSelectedSubjectsForClass()
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getSubjectList () {
      try {
        const response = await subjectList(this.customer_id)
        this.subject_list = response.data.data.subjects
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
